module.exports = __webpack_public_path__ + "static/media/metaverse-title.519648db.png";